import React, { useState, useEffect } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, isSameMonth, isSameDay, addMonths, subMonths, isToday } from 'date-fns';
import './BookingCalendar.css';

function BookingCalendar() {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await fetch('http://priyanthabandara.lk/get_bookings.php');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setBookings(data);
        setLoading(false);
      } catch (error) {
        console.error("Error loading bookings:", error);
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
    setSelectedDate(null);
    setSelectedBooking(null);
  };

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
    setSelectedDate(null);
    setSelectedBooking(null);
  };

 const handleDateClick = (day) => {
  setSelectedDate(day);
  const bookingsForDate = getBookingForDate(day);
  setSelectedBooking(bookingsForDate);
};

  const renderHeader = () => {
    return (
      <div className="calendar-header">
        <button className="nav-button" onClick={prevMonth}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <h2 className="month-title">{format(currentMonth, 'MMMM yyyy')}</h2>
        <button className="nav-button" onClick={nextMonth}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = 'EEE';
    const days = [];
    const startDate = startOfMonth(currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="day-name" key={i}>
          {format(new Date(startDate.setDate(i + 1)), dateFormat)}
        </div>
      );
    }

    return <div className="days-row">{days}</div>;
  };

  const isBooked = (day) => {
    return bookings.some(booking => {
      const dates = [
        booking.weddingDate,
        booking.homecomingDate,
        booking.preshootDate
      ].filter(date => date);
      
      return dates.some(date => isSameDay(new Date(date), day));
    });
  };

 const getBookingForDate = (day) => {
  return bookings.filter(booking => {
    const dates = [
      { date: booking.weddingDate, type: 'Wedding' },
      { date: booking.homecomingDate, type: 'Homecoming' },
      { date: booking.preshootDate, type: 'Preshoot' }
    ].filter(item => item.date);
    
    return dates.some(item => isSameDay(new Date(item.date), day));
  }).map(foundBooking => {
    const eventTypes = [
      { date: foundBooking.weddingDate, type: 'Wedding' },
      { date: foundBooking.homecomingDate, type: 'Homecoming' },
      { date: foundBooking.preshootDate, type: 'Preshoot' }
    ].filter(item => item.date && isSameDay(new Date(item.date), day));
    
    return {
      ...foundBooking,
      eventTypes: eventTypes.map(item => item.type)
    };
  });
};

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const daysInMonth = eachDayOfInterval({ start: monthStart, end: monthEnd });

    // Calculate the number of days to pad at the beginning
    const startDay = monthStart.getDay();
    const paddingDays = Array.from({ length: startDay }, (_, i) => (
      <div key={`pad-${i}`} className="day-cell pad"></div>
    ));

    return (
      <div className="calendar-body">
        {paddingDays}
        {daysInMonth.map((day, i) => {
          const booked = isBooked(day);
          const booking = booked ? getBookingForDate(day) : null;
          const isSelected = selectedDate && isSameDay(selectedDate, day);
          const isCurrentDay = isToday(day);
          
          return (
            <div
              key={i}
              className={`day-cell ${booked ? 'booked' : ''} ${isSelected ? 'selected' : ''} ${isCurrentDay ? 'today' : ''}`}
              onClick={() => handleDateClick(day)}
            >
              <span className="day-number">{format(day, 'd')}</span>
              {booked && (
  <div className="booking-info">
    <small>Booked</small> {/* Or show first booking's number */}
  </div>
)}
            </div>
          );
        })}
      </div>
    );
  };

 const renderBookingDetails = () => {
  if (!selectedBooking || selectedBooking.length === 0) return null;

  return (
    <div className="booking-details-panel">
      <h3>Booking Details ({selectedBooking.length})</h3>
      {selectedBooking.map((booking, index) => (
        <div key={index} className="booking-item">
          <div className="detail-row">
            <span className="detail-label">Quotation #:</span>
            <span className="detail-value">{booking.quotationNumber}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Customer:</span>
            <span className="detail-value">{booking.customerName}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Contact:</span>
            <span className="detail-value">{booking.telephoneNo}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Event Type:</span>
            <span className="detail-value">{booking.eventTypes.join(', ')}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Package:</span>
            <span className="detail-value">{booking.packageSelected}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Advance Payment:</span>
            <span className="detail-value">LKR {booking.advance}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Date:</span>
            <span className="detail-value">{format(selectedDate, 'MMMM do, yyyy')}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Status:</span>
            <span className="detail-value">{booking.status}</span>
          </div>
          {index < selectedBooking.length - 1 && <hr className="booking-separator" />}
        </div>
      ))}
    </div>
  );
};

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading bookings...</p>
      </div>
    );
  }

  return (
    <div className="booking-calendar-container">
      <div className="booking-calendar">
        <div className="calendar-header-main">
          <h1>Booking Calendar</h1>
        </div>
        
        <div className="calendar-wrapper">
          <div className="calendar-main">
            {renderHeader()}
            {renderDays()}
            {renderCells()}
          </div>
          
          {renderBookingDetails()}
        </div>
        
        <div className="calendar-footer">
          <div className="calendar-legend">
            <div className="legend-item">
              <span className="legend-dot available"></span>
              <span>Available</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot booked"></span>
              <span>Booked</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot today"></span>
              <span>Today</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingCalendar;